import { render, staticRenderFns } from "./product_info_param.vue?vue&type=template&id=41ea1fb9&scoped=true"
import script from "./product_info_param.vue?vue&type=script&lang=js"
export * from "./product_info_param.vue?vue&type=script&lang=js"
import style0 from "./product_info_param.vue?vue&type=style&index=0&id=41ea1fb9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ea1fb9",
  null
  
)

export default component.exports